<script setup lang="ts">
import RatingStar from '~/components/product/review/RatingStar.vue'
import type { AppRatingsBreakdown } from '~/types/product.model'

const props = defineProps<{
  ratingsBreakdown: AppRatingsBreakdown
}>()

const numberOfTotalRatings = computed(() => {
  return Object.values(props.ratingsBreakdown || {}).reduce((sum, count) => sum + count, 0)
})

const breakdownPercentages = computed(() => {
  return props.ratingsBreakdown.map((numberOfRatings, index) => {
    const percentage = numberOfTotalRatings.value > 0 ? (numberOfRatings / numberOfTotalRatings.value) * 100 : 0
    const rating = index + 1
    return { rating, numberOfRatings, percentage: percentage.toFixed(0) }
  }).reverse()
})
</script>

<template>
  <div class="ratings-breakdown">
    <template
      v-for="(rating) in breakdownPercentages"
      :key="rating.rating"
    >
      <span>{{ rating.rating }}</span>
      <RatingStar />
      <label class="ratings-breakdpown__label">
        <span class="sr-only">{{ rating.numberOfRatings }} {{ rating.numberOfRatings === 1 ? 'user' : 'users' }} rated this app {{ rating.rating }} out of 5</span>
        <meter
          class="ratings-breakdown__meter"
          max="100"
          :value="rating.percentage"
        />
      </label>
      {{ rating.percentage }}%
    </template>
  </div>
</template>

<style lang="scss" scoped>
.ratings-breakdown {
  display: grid;
  grid-template-columns: 12px 15px auto 40px;
  grid-auto-rows: 24px;
  gap: var(--app-spacer-4);
  align-items: center;
}

.ratings-breakdown__meter {
  padding: 0 var(--app-spacer-8);
  width: 100%;
}

.ratings-breakdown__meter::-webkit-meter-optimum-value {
  background: var(--app-color-dark-blue);
}
</style>
